import { type SuretyAccountId, type WorkInProgressScheduleExtractionId } from "@inrev/common";

export const wipExtractionsQueryKey = (
	accountId: SuretyAccountId,
	extractionId?: WorkInProgressScheduleExtractionId,
) =>
	extractionId
		? (["accounts", accountId, "wip-extractions", extractionId] as const)
		: (["accounts", accountId, "wip-extractions"] as const);

export const wipLineItemsQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "wip-line-items"] as const;

export const wipProjectsQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "wip-projects"] as const;

export const wipStatementsQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "wip-statements"] as const;
